import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function AppShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="flex h-full flex-col bg-white">
      <header className="flex items-center justify-between border-b border-lex-slate-200 px-4 py-3">
        <div className="flex items-center gap-2">
          <span
            aria-hidden
            className="inline-block h-2.5 w-2.5 rounded-full bg-lex-magenta"
          />
          <span className="text-sm font-semibold tracking-tight">
            {t('app.title')}
          </span>
        </div>
        <span className="text-xs text-lex-slate-500">{t('app.subtitle')}</span>
      </header>
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}
